<template>
  <ul class="menu-list">
    <template v-for="(item, index) in menuList" :key="index">
      <MenuItemElement :name="item.name" :path="item.path" :svg="item.svg" />
    </template>
  </ul>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import {MenuItemElement} from "@domains/dashboard";

export interface MenuListItem {
    name: string,
    icon: string,
    svg: string,
    path: string
  }

export default defineComponent({
  name: 'MenuListWidget',
  components: {
    MenuItemElement,
  },
  data() {
    // TODO: @Mehmet Çeliksoy: Should we got menu item from backend?
    return {
      menuList: [
        // {
        //   name: 'Dashboard',

        //   svg: 'dashboard.svg',
        //   path: '/dashboard',
        // },
        // {
        //   name: 'Estimation',

        //   svg: 'estimation.svg',
        //   path: '#',
        // },
      ] as MenuListItem[],
    };
  },
});

</script>

<style lang="scss" scoped>

  ul {
    list-style-type: none;
    padding: 0;
    margin: var(--space-0);
  }

</style>
